export default "__VITE_ASSET__DACXdGvG__"